import { useEffect } from 'react';
import {
  Box,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId5 = ['no15'];

const 영역5 = [
  {
    id: 1,
    ko: '15. 기저귀 교환',
    info: ['간호직원이 직접 시행한 경우 해당, 3회 이상'],
    desc: ['해당 없음', '2점'],
  },
];

const radioId6 = ['no16', 'no17', 'no18'];

const 영역6 = [
  {
    id: 1,
    ko: '16. 자세변경',
    info: ['간호직원이 직접 시행한 경우로 환자가 완전 도움이 필요한 경우 해당'],
    desc: ['해당 없음', '2점 : 3~5회', '3점 : 6회 이상'],
  },
  {
    id: 2,
    ko: '17. 환자 이동',
    info: [
      '‘침상에서 의자나 스트레처로 이동’ 또는 ‘의자나 스트레처에서 침상’으로 이동한 경우가 각각 1회에 해당',
    ],
    desc: ['해당 없음', '1점 : 2~3회', '2점 : 4회 이상'],
  },
  {
    id: 3,
    ko: '18. 침상에서 일어나 걷도록 도와주기',
    info: ['간호직원이 직접 시행한 경우 해당'],
    desc: ['해당 없음 ', '2점'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum5: number;
  setSum5: (sum5: number) => void;

  sum6: number;
  setSum6: (sum6: number) => void;
}

const KPCSCGWontents3 = (props: Props) => {
  const { disabled, setValue, getValues, setSum5, setSum6, register } = props;

  const calculateSumValue5 = () => {
    setSum5(
      radioId5.reduce((acc, cur) => {
        const value = Number(getValues(cur)) * 2;
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange5 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue5();
  };

  const calculateSumValue6 = () => {
    setSum6(
      radioId6.reduce((acc, cur) => {
        if (cur === 'no16' || cur === 'no18') {
          if (Number(getValues(cur)) > 0) {
            // @ts-ignore
            const value = Number(getValues(cur)) + 1;
            return value ? acc + value : acc;
          }
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange6 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue6();
  };

  useEffect(() => {
    calculateSumValue5();
    calculateSumValue6();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 배설" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역5.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 'none',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo sx={{ borderBottom: 'none' }}>
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId5[content.id - 1]}
                      defaultValue={Number(getValues(radioId5[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point.includes('no')) {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                                height: '43px',
                              }}
                            ></TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId5[content.id - 1]}
                                  value={i}
                                  onChange={handleChange5}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{ borderBottom: 'none' }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => (
                        <TableRow
                          sx={{
                            lineHeight: '42px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}>{v}</Box>
                        </TableRow>
                      ))}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 기동성" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역6.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역6.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역6.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId6[content.id - 1]}
                      defaultValue={Number(getValues(radioId6[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId6[content.id - 1]}
                                value={i}
                                onChange={handleChange6}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역6.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCGWontents3;
